module.exports = __webpack_public_path__ + "static/media/upload_doc_banner.21983364.svg";